import { iGameTemplate, iSquareSaved, iCluesInfos, iGameState } from "../context/interfaces";
import { searchHorizontalReverse, searchVerticalReverse } from "./searchs";
import setSubFocus from "./setSubFocus";


export default function getPreviousClue(
  gameState: iGameState,
  gameTemplate: iGameTemplate,
): void {
  // currentClueText: string,
  // currentClueNumber: string,
  // orientation: "horizontal" | "vertical",
  // focusedHouse: { x: number, y: number },
  const { matrix: matrixTemplate  } = gameTemplate;
  const { matrix } = gameState.savedGame.cache;
  const { row } = gameState.focusedHouse;

  if (gameState.orientation === "horizontal") {
    //search previous possible house in the current row to focus
    for (let column = gameState.focusedHouse.column; column >= 0; column--) {
      if (matrix[row][column]?.palavraHorizontal !== -1 && matrix[row][column].palavraHorizontal?.toString() !== gameState.currentClueNumber) {
        if (matrix[row][column]?.letra === null || matrix[row][column]?.letra === '') {
          //We have a avaible house
          gameState.currentClueNumber = matrix[row][column].palavraHorizontal.toString();

          gameState.currentClueText = gameTemplate.chaves.horizontal[matrix[row][column].palavraHorizontal.toString()][0].chave;
          var subFocus = setSubFocus({
            selectedClue: gameState.currentClueNumber,
            orientation: "horizontal",
            focusedHouse: { column, row },
            houseStates: gameState.houseStates
          });
          gameState.houseStates = subFocus.houseStates;
          gameState.focusedHouse = subFocus.focusedHouse;
          return;
        }
      }
    }

    //if has more rows search previous possible house on previous rows
    if (gameState.focusedHouse.row - 1 >= 0) {
    for (let row = gameState.focusedHouse.row - 1; row > 0; row--) {
      for (let column = matrixTemplate[0].length - 1; column > 0; column--) {
        if (matrix[row][column]?.palavraHorizontal !== -1 && matrix[row][column].palavraHorizontal?.toString() !== gameState.currentClueNumber) {
          if (matrix[row][column]?.letra === null || matrix[row][column]?.letra === '') {
            //We have a avaible house
            gameState.currentClueNumber = matrix[row][column].palavraHorizontal.toString();
            gameState.currentClueText = gameTemplate.chaves.horizontal[matrix[row][column].palavraHorizontal.toString()][0].chave;
            var subFocus = setSubFocus({
              selectedClue: gameState.currentClueNumber,
              orientation: "horizontal",
              focusedHouse: { column, row },
              houseStates: gameState.houseStates
            });
            gameState.houseStates = subFocus.houseStates;
            gameState.focusedHouse = subFocus.focusedHouse;
            return;
          }
        }
      }
    }
  }
    //turn the orientation to vertical and  search reverse  vertical
    var verticalResult = searchVerticalReverse(gameState.savedGame.cache.matrix, gameTemplate, "", "", "vertical")
    if (false !== verticalResult) {
      gameState.currentClueNumber = verticalResult.clueNumber;
      gameState.currentClueText = verticalResult.clueText;
      var subFocus = setSubFocus({
        selectedClue: gameState.currentClueNumber,
        orientation: "vertical",
        focusedHouse: { column: verticalResult.focusedHouse.column, row: verticalResult.focusedHouse.row },
        houseStates: gameState.houseStates
      });
      gameState.orientation = "vertical";
      gameState.houseStates = subFocus.houseStates;
      gameState.focusedHouse = {
        column: verticalResult.focusedHouse.column,
        row: verticalResult.focusedHouse.row
      };
      return;
    }

    //turn the orientation to horizontal and  search reverse  horizontal
    var horizontalResult = searchHorizontalReverse(gameState.savedGame.cache.matrix, gameTemplate, "", "", "horizontal");
    if (false !== horizontalResult) {
      gameState.currentClueNumber = horizontalResult.clueNumber;
      gameState.currentClueText = horizontalResult.clueText;
      var subFocus = setSubFocus({
        selectedClue: gameState.currentClueNumber,
        orientation: "horizontal",
        focusedHouse: { column: horizontalResult.focusedHouse.column, row: horizontalResult.focusedHouse.row },
        houseStates: gameState.houseStates
      });
      gameState.orientation = "horizontal";
      gameState.focusedHouse = {
        column: horizontalResult.focusedHouse.column,
        row: horizontalResult.focusedHouse.row
      };
      return;
    }
    //if not found any clue, finish the game
    gameState.completed = true;
    console.log("Game finished!");



  } else if (gameState.orientation === "vertical") {
    //search previous possible house in the current column to focus
    for (let row = gameState.focusedHouse.row; row >= 0; row--) {
      if (matrix[row][gameState.focusedHouse.column]?.palavraVertical !== -1 && matrix[row][gameState.focusedHouse.column]?.palavraVertical?.toString() !== gameState.currentClueNumber) {
        if (matrix[row][gameState.focusedHouse.column]?.letra === null || matrix[row][gameState.focusedHouse.column]?.letra === '') {
          //We have a avaible house
          gameState.currentClueNumber = matrix[row][gameState.focusedHouse.column].palavraVertical.toString();
          gameState.currentClueText = gameTemplate.chaves.vertical[matrix[row][gameState.focusedHouse.column].palavraVertical.toString()][0].chave;
          var subFocus = setSubFocus({
            selectedClue: gameState.currentClueNumber,
            orientation: "vertical",
            focusedHouse: { column: gameState.focusedHouse.column, row: row },
            houseStates: gameState.houseStates
          });
          gameState.houseStates = subFocus.houseStates;
          gameState.focusedHouse = subFocus.focusedHouse;
          return;
        }
      }
    }

    //if has more columns search previous possible house on previous columns
    if (gameState.focusedHouse.column - 1 >= 0) {
    for (let column = gameState.focusedHouse.column - 1; column > 0; column--) {
      for (let row = matrixTemplate.length - 1; row > 0; row--) {
        if (matrix[row][column]?.palavraVertical !== -1 && matrix[row][column].palavraVertical?.toString() !== gameState.currentClueNumber) {
          if (matrix[row][column]?.letra === null || matrix[row][column]?.letra === '') {
            //We have a avaible house
            gameState.currentClueNumber = matrix[row][column].palavraVertical.toString();
            gameState.currentClueText = gameTemplate.chaves.vertical[matrix[row][column].palavraVertical.toString()][0].chave;
            var subFocus = setSubFocus({
              selectedClue: gameState.currentClueNumber,
              orientation: "vertical",
              focusedHouse: { column, row },
              houseStates: gameState.houseStates
            });
            gameState.houseStates = subFocus.houseStates;
            gameState.focusedHouse = subFocus.focusedHouse;
            return;
          }
        }
      }
    }

  }

    //turn the orientation to horizontal and  search reverse  horizontal
    var horizontalResult = searchHorizontalReverse(gameState.savedGame.cache.matrix, gameTemplate, "", "", "horizontal");
    if (false !== horizontalResult) {
      gameState.currentClueNumber = horizontalResult.clueNumber;
      gameState.currentClueText = horizontalResult.clueText;
      var subFocus = setSubFocus({
        selectedClue: gameState.currentClueNumber,
        orientation: "horizontal",
        focusedHouse: { column: horizontalResult.focusedHouse.column, row: horizontalResult.focusedHouse.row },
        houseStates: gameState.houseStates
      });
      gameState.orientation = "horizontal";
      gameState.focusedHouse = {
        column: horizontalResult.focusedHouse.column,
        row: horizontalResult.focusedHouse.row
      };
      return;
    }
    //turn the orientation to vertical and  search reverse  vertical
    var verticalResult = searchVerticalReverse(gameState.savedGame.cache.matrix, gameTemplate, "", "", "vertical")
    if (false !== verticalResult) {
      gameState.currentClueNumber = verticalResult.clueNumber;
      gameState.currentClueText = verticalResult.clueText;
      var subFocus = setSubFocus({
        selectedClue: gameState.currentClueNumber,
        orientation: "vertical",
        focusedHouse: { column: verticalResult.focusedHouse.column, row: verticalResult.focusedHouse.row },
        houseStates: gameState.houseStates
      });
      gameState.orientation = "vertical";
      gameState.focusedHouse = {
        column: verticalResult.focusedHouse.column,
        row: verticalResult.focusedHouse.row
      };
      return;
    }
    //if not found any clue, finish the game
    gameState.completed = true;
    console.log("Game finished!");

  }

}

